<template>
  <div class="step">
    <div class="step__container">
      <div class="step__header">Pris og kontaktinformation</div>
      <div class="step__text">
        Her skal du sætte prisen på din
        {{ privateAdFlowProductTypeNames.nameSingular }} samt udfylde dine
        kontaktinformationer
      </div>
      <!--
        Jeg har lavet et check på om vehicleData.productType eksisterer - hvis den gør tager den id fra den - ellers bare 0 - ved ikke om dette er rigtigt
      -->
    </div>
    <p
      class="step__section-header step__section-header--extra-padding step__input--required"
    >
      <span>Hvad er din pris?</span>
    </p>
    <SetPriceValue
      :event-bus="eventBus"
      :product-type-id="
        vehicleData.productType ? vehicleData.productType.id : 0
      "
      :initial-price="initialPriceObj"
      ref="priceValueComponent"
    ></SetPriceValue>
    <FactBox
      :title="'Tip til prissætning'"
      :body="`Når du fastsætter prisen, så læg dig på linje med 
         lignende ${privateAdFlowProductTypeNames.namePlural}.
         Du kan altid justere prisen senere. Prøv også vores 
         bytteprisberegner på biltorvet.dk, som du finder på 
         annoncesiden for en lignende bil.`"
      class="set-price-value__fact-box"
    />
    <p
      class="step__section-header step__section-header--extra-padding step__input--required"
    >
      Dine kontaktoplysninger
    </p>
    <UserEdit :stand-alone="false" :event-bus="eventBus" ref="userEdit" />
    <!-- // TODO: INSERT ContactInformation component here
      use eventBus and emit using 'set-contact-information-callback' passing a ProductContactInformation object
      Husk at sende eventBus + errorCollection + vehicleData (for contactInformation) til komponenten
     -->
    <!--
       Hvorfor skal der sendes errorCollection + vehicleData til komponenten? Skal du ikke bare have data fra komponenten + om den er valid eller ej?
    -->
    <FactBox
      :title="'Dine kontaktinformationer'"
      :body="'Vi passer godt på dine personlige oplysninger. Du kan læse mere i vores privatlivspolitik ved at klikke på linket herunder.'"
      :linkHref="'/cookiepolitik'"
      :linkText="'Privatlivs- og cookiepolitik'"
      :linkTarget="'_blank'"
    />
    <!-- TODO: tjek at link til privatlivspolitik er det rigtige -->
    <StepButtonPanel
      :event-bus="eventBus"
      :back-visible="true"
      :next-visible="true"
      :next-enabled="true"
      :is-update="isUpdate"
      :validate-function="validate"
    ></StepButtonPanel>
  </div>
</template>
<script>
import { scrollToView } from './StepsFunctions'
import UserEdit from '@components/User/Edit/UserEdit.vue'
import FactBox from '@components/FactBox/FactBox.vue'
import StepButtonPanel from '../Components/StepButtonPanel/StepButtonPanel.vue'
import SetPriceValue from '../Components/SetPriceValue/SetPriceValue.vue'

export default {
  components: {
    StepButtonPanel,
    SetPriceValue,
    UserEdit,
    FactBox,
  },
  props: {
    eventBus: { default: null, type: Object },
    vehicleData: {
      default: () => {
        return {}
      },
      type: Object,
    },
    errorCollection: {
      default: () => {
        return []
      },
      type: Array,
    },
    privateAdFlowProductTypeNames: {
      default: () => {
        return {}
      },
      type: Object,
    },
    isUpdate: { default: false, type: Boolean },
  },
  data() {
    return {
      initialPriceObj: {},
      nameFirst: '',
      nameLast: '',
      email: '',
      zipcode: '',
      phonenumber: '',
      contactInfoRequirementsFulfilled: true,
      contactInfoErrorCollection: [],
      inProgress: false,
    }
  },
  methods: {
    validate() {
      let isValid = true
      // Validerer i omvendt rækkefølge for at ramme
      let errorContainer = ''

      if (!this.$refs.userEdit.isValid()) {
        isValid = false
        errorContainer = 'userEdit'
      }

      if (!this.$refs.priceValueComponent.isValid()) {
        isValid = false
        errorContainer = 'priceValueComponent'
      }

      if (!isValid) {
        setTimeout(() => {
          scrollToView(this.$refs[errorContainer].$el, 50)
        }, 50)
      }

      return isValid
    },
    setContactInformation(input) {
      this.nameFirst = input.firstname
      this.nameLast = input.lastname
      this.email = input.email
      this.zipcode = input.zipcode
      this.phonenumber = input.phonenumber
      this.contactInfoRequirementsFulfilled = input.requirementsFulfilled
      this.contactInfoErrorCollection = input.errorCollection
      this.inProgress = input.inProgress
    },
    validateAndSaveContactInformations() {
      return this.$refs.userEdit.emitData(false)
    },
  },
  created() {
    window.scrollTo(0, 0)
    this.initialPriceObj = {}
    if (this.vehicleData && this.vehicleData.priceInformation) {
      this.initialPriceObj = this.vehicleData.priceInformation
    }
  },
  mounted() {
    if (!this.eventBus) return
    this.eventBus.on(
      'set-contact-information-callback',
      this.setContactInformation
    )

    this.eventBus.emit('stepLoaded', 4)
  },
}
</script>

<style lang="scss">
@import 'Step.scss';
</style>
